import { AxiosInstance } from 'axios';
import {
    PreorderDetailsGeneralInfo,
    PreorderFilterType,
    PreorderTableItem,
} from 'models/api/preorder';
import ResTable from 'models/api/table';
import { Key } from 'react';
import { DropDown } from '@finbeat/react-toolkit';

const controller = '/preorder';

export const getPreorders = async (axios: AxiosInstance, requestParams: PreorderFilterType) => {
    const params = { ...requestParams };
    const { data } = await axios.get<ResTable<PreorderTableItem>>(controller, { params });
    return data;
};

export const getPreordersExcel = async (axios: AxiosInstance, params: PreorderFilterType) => {
    const { data } = await axios.get<Blob>(controller + '/excel', {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return data;
};

export const getPreorderStatuses = async (axios: AxiosInstance) => {
    const { data } = await axios.get<DropDown[]>(controller + '/orderStatuses');
    return data;
};

export const getPreorderGeneralInfo = async (axios: AxiosInstance, id: Key) => {
    const { data } = await axios.get<PreorderDetailsGeneralInfo>(controller + `/${id}`);
    return data;
};
